import Vue from 'vue'
import Vuex from 'vuex'

import operator from './operator.module'
import user from './user.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    operator
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js